export class CollectionConstant {
  public static LABELS: any = {
    allFrameworks: 'All Frameworks',
    managerTilePlural: 'The managers that are assigned to this framework are : ',
    managerTileSingular: 'The manager that is assigned to this framework is : ',
    all: 'All',
  };
  public static EXPORT_OPTIONS: any = {
    EXPORT: 'General Report (XLS)',
    EXPORT_CSV: 'General Report (CSV)',
    DOWNLOAD: 'All Artifacts (ZIP)',
    EXPORT_ACTIVITY_LOGS: 'Activity Logs (CSV)',
    DOWNLOAD_AUDIT_REPORT: 'Internal Audit Report',
    DOWNLOAD_MID_MARKET_REPORT: 'MidMarket Report',
    DOWNLOAD_BEAZLEY_REPORT: 'Insurance Application (DOCX)',
    DOWNLOAD_BEAZLEY_IA_OT: 'Insurance Application + OT (DOCX)',
    DOWNLOAD_B_APP_RSWOT_TEO: 'Insurance Application + OT & TEO (DOCX)',
    DOWNLOAD_BEAZLEY_TEO: 'Insurance Application + TEO (DOCX)',
    DOWNLOAD_NISD_REPORT: 'NIS-D Report',
    DOWNLOAD_CMMC_REPORT: 'CMMC SSP (DOCX)',
    DOWNLOAD_CMMC_POAM_DOCX_REPORT: 'CMMC POA&M (DOCX)',
    DOWNLOAD_CMMC_POAM_XLSX_REPORT: 'CMMC POA&M (XLSX)',
    DOWNLOAD_REPORT: 'PCI Report (DOC)',
    DOWNLOAD_NIST_800_171: 'System Security Plan (DOC)',
    DOWNLOAD_ISO_27001_2022_V1: 'Statement of Applicability (SOA)',
    DOWNLOAD_NIS2_COMPLIANCE_REPORT: 'NIS2 Assessment Report',
    DOWNLOAD_NIS2_SELF_ASSESSMENT_EXCEL: 'NIS2 Assessment (Excel)',
    DOWNLOAD_DXC_CMR_REPORT: 'DXC CMR Report (DOCX)',
  };
  public static HITRUST_POINTS: any = {
    POLICY: 15,
    PROCESS: 20,
    IMPLEMENTED: 40,
    MEASURED: 10,
    MANAGED: 15,
  };
}

export enum FRAMEWORKS_WITH_DISABLED_SETTINGS {
  DOWNLOAD_BEAZLEY_REPORT = 'Download Beazley Report',
  DOWNLOAD_BEAZLEY_IA_OT = 'Download Insurance Application with OT',
  DOWNLOAD_NISD_REPORT = 'Download NIS-D Report',
  DOWNLOAD_REPORT = 'Download Report',
}

export enum INSURANCE_APP_FRAMEWORKS {
  BEAZLEY = 'BEAZLEY',
  InsuranceWithOT = 'B_APP_RSWOT',
  InsuranceWithOTAndTEO = 'B_APP_RSWOT_TEO',
  BEAZLEY_TEO = 'BEAZLEY_TEO',
}

export enum MID_MARKET_FRAMEWORKS {
  MID_MARKET_BASIC = 'MID_MARKET_BASIC', //* Mid Market Application BASIC
  MID_MARKET_BASIC_OT = 'MID_MARKET_BASIC_OT', //* Mid Market Application + OT
  MID_MARKET_BASIC_TECH = 'MID_MARKET_BASIC_TECH', //* Mid Market Application + Tech E&O
  MID_MARKET_APPLICATION = 'MID_MARKET_APPLICATION', // * Mid Market Application + OT + Tech E&O [FULL]
  MMU_APP_QUEST_SUPPLEMENT = 'MMU_APP_QUEST_SUPPLEMENT', //* MMU Over $500M
}

export enum PCI_FRAMEWORKS {
  PCI_DSS_4_0 = 'PCI_DSS_4.0',
  PCI_SAQ_D_MER_4_0 = 'PCI_SAQ_D_MER_4.0',
  PCI_SAQ_D_SP_4_0 = 'PCI_SAQ_D_SP_4.0',
  PCI_SAQ_P2PE_4_0 = 'PCI_SAQ_P2PE_4.0',
  PCI_SAQ_A_EP_4_0 = 'PCI_SAQ_A_EP_4.0',
  PCI_SAQ_A_4_0 = 'PCI_SAQ_A_4.0',
  PCI_SAQ_B_4_0 = 'PCI_SAQ_B_4.0',
  PCI_SAQ_B_IP_4_0 = 'PCI_SAQ_B_IP_4.0',
  PCI_SAQ_C_4_0 = 'PCI_SAQ_C_4.0',
  PCI_SAQ_C_VT_4_0 = 'PCI_SAQ_C_VT_4.0',
  PCI_SAQ_SPOC_4_0 = 'PCI_SAQ_SPOC_4.0',
  PCI_SAQ_A_4_0_1 = 'PCI_SAQ_A_4.0.1',
  PCI_SAQ_B_4_0_1 = 'PCI_SAQ_B_4.0.1',
  PCI_SAQ_P2PE_4_0_1 = 'PCI_SAQ_P2PE_4.0.1',
  PCI_SAQ_C_VT_4_0_1 = 'PCI_SAQ_C_VT_4.0.1',
  PCI_SAQ_SPOC_4_0_1 = 'PCI_SAQ_SPOC_4.0.1',
  PCI_SAQ_C_4_0_1 = 'PCI_SAQ_C_4.0.1',
  PCI_SAQ_B_IP_4_0_1 = 'PCI_SAQ_B_IP_4.0.1',
  PCI_SAQ_A_EP_4_0_1 = 'PCI_SAQ_A_EP_4.0.1',
  PCI_SAQ_D_MER_4_0_1 = 'PCI_SAQ_D_MER_4.0.1',
  PCI_SAQ_D_SP_4_0_1 = 'PCI_SAQ_D_SP_4.0.1',
  PCI_DSS_4_0_1 = 'PCI_DSS_4.0.1',
}

export const PCI_401_FRAMEWORKS: string[] = [
  PCI_FRAMEWORKS.PCI_DSS_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_A_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_A_EP_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_B_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_B_IP_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_C_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_D_MER_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_D_SP_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_P2PE_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_SPOC_4_0_1,
  PCI_FRAMEWORKS.PCI_SAQ_C_VT_4_0_1,
];

export enum CMMC_FRAMEWORKS {
  CMMC_LEVEL_1_V2 = 'CMMC_LEVEL_1_V2',
  CMMC_LEVEL_2_V2 = 'CMMC_LEVEL_2_V2',
  CMMC_LEVEL_3_V2_13 = 'CMMC_LEVEL_3_V2.13',
  CMMC_LEVEL_1_V2_13_1 = 'CMMC_LEVEL_1_V2.13.1',
  CMMC_LEVEL_2_V2_13_1 = 'CMMC_LEVEL_2_V2.13.1',
  CMMC_LEVEL_3_V2_13_1 = 'CMMC_LEVEL_3_V2.13.1',
}

export enum HITRUST_SHEET_VAL {
  D1 = 'INFORMATION_PROTECTION_PROGRAM',
  D2 = 'ENDPOINT_PROTECTION',
  D3 = 'PORTABLE_MEDIA_SECURITY',
  D4 = 'MOBILE_DEVICE_SECURITY',
  D5 = 'WIRELESS_SECURITY',
  D6 = 'CONFIGURATION_MANAGEMENT',
  D7 = 'VULNERABILITY_MANAGEMENT',
  D8 = 'NETWORK_PROTECTION',
  D9 = 'TRANSMISSION_PROTECTION',
  D10 = 'PASSWORD_MANAGEMENT',
  D11 = 'ACCESS_CONTROL',
  D12 = 'AUDIT_LOGGING_AND_MONITORING',
  D13 = 'EDUCATION_TRAINING_AND_AWARENESS',
  D14 = 'THIRD_PARTY_ASSURANCE',
  D15 = 'INCIDENT_MANAGEMENT',
  D16 = 'BUSINESS_CONTINUITY_AND_DISASTER_RECOVERY',
  D17 = 'RISK_MANAGEMENT',
  D18 = 'PHYSICAL_AND_ENVIRONMENTAL_SECURITY',
  D19 = 'DATA_PROTECTION_AND_PRIVACY',
}

export const PCI_REPORT_ZIP_LABEL = 'PCI Report (ZIP)';
export const PCI_TOASTER_MESSAGE = `The generation of this report can take up to several minutes. You may continue working in the platform, 
  but please do not close or exit the platform before the report is downloaded.`;

export const BEAZLEY_TOASTER_MESSAGE = `Your file is being downloaded in the background.<br>
  This process can take several minutes.
  You can continue using any part of the
  Centraleyes platform as long as you do not close
  or refresh the browser.`;

// These are the controls whose artifacts are the part of Reports so they are must be in Docx format
export const REPORT_CONTROLS = {
  VENDOR_RISK_HOWDEN_CYBER_360: ['HW-1', 'HW-15', 'HW-43.5'],
  VENDOR_RISK_HOWDEN_RANSOMWARE: ['HW-48.a'],
  VENDOR_RISK_HOWDEN_FULL: ['HW-1', 'HW-15', 'HW-43.5', 'HW-48.a'],
  Beazley: ['ML-1', 'EXP-1', 'RS-49'],
  B_APP_RSWOT: ['ML-3', 'PCC-6', 'PCC-7'],
};

//* Reassessment Confirm All Constants
export const REASSESSMENT_CONFIRM_All = {
  LAMBDA_NAME: 'reassessmentConfirmAll',
  EVENT_TYPE_CONFIRM_ALL: 'CONFIRM_All',
  INFO_MESSAGE: 'Confirming all questions in the background. This may take a couple of seconds.',
};

export const REASSESSMENT_TRIGGER = {
  LAMBDA_NAME: 'reassessmentTrigger',
  EVENT_TYPE_END_REASSESSMENT: 'END_REASSESSMENT',
};

export const NA_SCORES = [999, 998];

export const NON_PARTIAL_ANSWERS = {
  BEECHER: [10, 1],
  MIDMARKET: [10, 1],
  OTHERS: [999, 998, 10, 0],
};

export const AVATAR_TOOLTIPS = {
  AVG: 'Average',
  AVG_TASK_OWNER_TOOLTIP: 'Average overwritten by the remediation task owner',
  GLOBAL_CONTROL_TOOLTIP: 'Answered by: Global Controls',
  INTEGRATION_TOOLTIP: 'Answered by: Integration',
  SMARTMAPPING_TOOLTIP: 'Answered by: Smart Mapping',
  AI_AGENT_TOOLTIP: 'Answered by: AI Agent',
};

//* This is used to split the guide in the Cyber Ark framework
export const GUIDE_DELIMITER = '[]';
export const NIST_800_171 = 'NIST_800_171';
export const NIST_800_171_RISK = 'NIST_800_171_RISK';
export const NIST_800_171_REV3_V1 = 'NIST_800_171_REV3_V1';
export const NIST_800_171_REV3_V1_RISK = 'NIST_800_171_REV3_V1_RISK';
export const ISO_27001_2022_V1 = 'ISO_27001_2022_V1';
export const ISO_27001_2022_COMPLIANCE = 'ISO_27001_2022_COMPLIANCE';
export const ISO_27701_2025_COMPLIANCE = 'ISO_27701_2025';

export const NIS2_SA_JAN26 = 'NIS2_SA_JAN26';
export const NIS2_SA_JAN26_RISK = 'NIS2_SA_JAN26_RISK';
// DXC Cyber Maturity Review report — base framework keys the assessmentReportEngine definition supports
// (mirrors amplify/backend/function/assessmentReportEngine/src/report_definitions/dxc_cmr.base.json → framework_keys).
export const DXC_CMR_FRAMEWORKS: string[] = ['DXC_IAM_V1.3', 'DXC_CMR_V0.2_v2', 'DXC_CMR_V0.2'];

export enum RTL_FRAMEWORKS {
  ICDM = 'ICDM',
  NIST_CSF_CRITICAL_AR = 'NIST_CSF_CRITICAL_AR',
  VENDOR_RISK_ELECTRA_SAQ = 'VENDOR_RISK_ELECTRA_SAQ',
}

export const UPDATE_QUESTION_TREE_LAMBDA = 'updateTreeHandler';

export const QUESTION_TYPE_TOOLTIP = `
<div class="tooltip-container">
    <p>Multi-User assignment of questions.</p>
    <p><b class="tooltip-heading">Collaborative</b> -
    two or more users
    work together to provide a shared answer back to the
    organization. Any update to the answer will overwrite the
    previous answer.</p>
    <p><b class="tooltip-heading">Single</b> - two or
    more users work
    separately to provide back their own individual answers to the
    question. The answers are automatically averaged and a a “AVG”
    user is added to provide the final result.</p>
</div>`;
